import { render } from "./WorkflowDialog.vue?vue&type=template&id=04f2da94&scoped=true"
import script from "./WorkflowDialog.vue?vue&type=script&lang=js"
export * from "./WorkflowDialog.vue?vue&type=script&lang=js"

import "./WorkflowDialog.vue?vue&type=style&index=0&id=04f2da94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f2da94"]])

export default __exports__